import 'whatwg-fetch';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import APIClient, { iterUnpack } from '../../services/APIClient';
import SegmentClient from '../../services/SegmentClient';
import BrandViewProjectsContent from './BrandViewProjectsContent';
import Alert from '../Alert';
import { ANALYTICS_NAME } from './Constants';

const BRAND_SLUG = document.getElementById('root').getAttribute('data-brand-slug');

const segment = new SegmentClient();

export default class BrandDetailProjects extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isFiltering: false,
      placements: [],
      levelTwoProjectTypesFacet: [],
      selectedProjectType: 'All',
      placementsCount: 0,
      brandName: '',
      metadata: {
        placements: {
          hasNextPage: false,
        },
      },
    };
  }

  UNSAFE_componentWillMount() {
    const props = iterUnpack(JSON.parse(window.props));
    const levelTwoProjectTypesFacet = [{
      name: 'All',
      count: props.allBrands[0].placementsCount || 0,
    }, ...props.allBrands[0].levelTwoProjectTypesFacet];

    const newState = {
      isLoading: false,
      isFiltering: false,
      placements: props.allBrands[0].placements || [],
      placementsCount: props.allBrands[0].placementsCount || 0,
      brandName: props.allBrands[0].name,
      levelTwoProjectTypesFacet,
    };

    if (props.metadata && props.metadata.placements) {
      newState.metadata = props.metadata;
    }

    this.setState(newState);
  }

  onProjectTypeChange = (filter) => {
    segment.track(ANALYTICS_NAME.BRAND_PROJECT_TYPE_FILTER_CHANGED);
    this.setState({
      levelTwoProjectTypesFacet: this.state.levelTwoProjectTypesFacet.map((e) => {
        if (e.name === filter.name) {
          e.isLoading = true;
        }
        return e;
      }),
      isFiltering: true,
    });
    this.fetchPlacementsList(filter.name, 'project-type-change');
  }

  fetchPlacementsList = (selectedFilter, action = 'project-type-change') => {
    let projectsFilterQuery = '';
    if (selectedFilter !== 'All') {
      projectsFilterQuery = `projectType: "${selectedFilter}",`;
    }
    let afterCursor = '';
    if (action === 'show-more') {
      afterCursor = `after: "${this.state.metadata.placements.endCursor}",`;
    }
    const query = `{
      allBrands(slug: "${BRAND_SLUG}", last: 1) {
        edges {
          node {
            placements: filteredPlacements(first: 8, ${projectsFilterQuery} ${afterCursor} orderBy: "-completion_date_dt") {
              edges {
                cursor
                node {
                  id
                  notes
                  project {
                    name
                    slug
                    location
                    completionDate
                    firms: leadFirms(first: 1) {
                      edges {
                        node {
                          slug
                          name
                          media(first: 1) {
                            ...mediaItem
                          }
                        }
                      }
                    }
                    tags(first: 3, tag_Parent_Parent_Slug: "${window.PROJECT_TYPE_TAGS_NODE_SLUG}") {
                      edges {
                        node {
                          tag {
                            slug
                            text 
                            parent {
                              slug
                            }
                          }
                        }
                      }
                    }
                    media(first: 1) {
                      ...mediaItem
                    }
                  }
                }
              }
              pageInfo {
                endCursor
                hasNextPage
              }
            }
          }
        }
      }
    }
    fragment mediaItem on MediaItemAttributionNodeConnection {
      edges {
        node {
          type
          mediaItem {
            id
            url
            originalName
          }
        }
      }
    }`;

    if (action === 'project-type-change' || (action === 'show-more' && this.state.metadata.placements.hasNextPage)) {
      APIClient(query, true)
        .then((data) => {
          if (action === 'show-more') {
            const newPlacements = Array.from(new Set([
              ...this.state.placements,
              ...data.allBrands[0].placements,
            ]));
            this.setState({
              metadata: data.metadata,
              placements: newPlacements,
              isLoading: false,
            });
          } else if (action === 'project-type-change') {
            const { levelTwoProjectTypesFacet, placementsCount } = this.state;
            // eslint-disable-next-line max-len
            const filteredPlacementsCount = levelTwoProjectTypesFacet.find(e => e.name === selectedFilter).count || placementsCount;
            this.setState({
              metadata: data.metadata,
              placements: data.allBrands[0].placements,
              selectedProjectType: selectedFilter,
              placementsCount: filteredPlacementsCount,
              levelTwoProjectTypesFacet: levelTwoProjectTypesFacet.map((e) => {
                e.isLoading = false;
                return e;
              }),
              isFiltering: false,
            });
          }
        });
    }
  }

  showMoreHandler = () => {
    segment.track(ANALYTICS_NAME.BRAND_SHOW_MORE_PLACEMENTS_CLICKED);
    this.setState({ isLoading: true });
    this.fetchPlacementsList(this.state.selectedProjectType, 'show-more');
  }

  render() {
    const {
      placements,
      metadata,
      isLoading,
      placementsCount,
      brandName,
      levelTwoProjectTypesFacet,
      isFiltering,
    } = this.state;
    const emptyMessage = this.props.emptyMessage || 'No Projects Available';
    return (
      <div className="row">
        <h3 className="columns small-12 pb-base fs-m fw-medium">
          <i className="material-icons">business</i>
          {' '}
          Projects
        </h3>
        {placements && placements.length
          ? (
            <div className="columns small-12">
              <BrandViewProjectsContent
                placements={placements}
                levelTwoProjectTypesFacet={levelTwoProjectTypesFacet}
                selectedProjectType={this.state.selectedProjectType}
                onProjectTypeChange={this.onProjectTypeChange}
                showMoreHandler={this.showMoreHandler}
                hasNextPage={metadata.placements.hasNextPage}
                isLoading={isLoading}
                placementsCount={placementsCount}
                brandName={brandName}
                isFiltering={isFiltering}
              />
            </div>
          )
          : (
            <Alert type="secondary" className="columns small-12">
              {isLoading
                ? <div className="loading-spinner-m" style={{ margin: 'auto' }} />
                : emptyMessage}
            </Alert>
          )}
        {!this.props.hideDivider
        && (
        <div className="columns small-12">
          <hr />
        </div>
        )}
      </div>
    );
  }
}

BrandDetailProjects.propTypes = {
  emptyMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  hideDivider: PropTypes.bool,
};

BrandDetailProjects.defaultProps = {
  emptyMessage: null,
  hideDivider: false,
};
